// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { languageMenuStyles } from "@insite/content-library/Widgets/Common/LanguageMenu";
import Globe from "@insite/mobius/Icons/Globe";
import { css } from "styled-components";

languageMenuStyles.languageWrapper = {
    css: css`
        display: flex;
        align-items: center;
        padding: 10px 0px;
    `,
};

languageMenuStyles.languageIcon = {
    size: 20,
    src: Globe,
    color: "primary.contrast",
    css: css`
        &&& {
            margin-right: 10px;
        }
    `,
};

languageMenuStyles.languageSelect = {
    backgroundColor: "common.accent",
    iconProps: {
        css: css`
            &&& {
                max-width: 18px;
                max-height: 18px;
                padding: 0px;
                top: 7px;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: 100px;
        `,
        inputSelect: css`
            height: 30px;
            border: none;
            text-transform: uppercase;
            font-size: 12px;
        `,
    },
};
